module.exports = __webpack_public_path__ + "static/media/poppins-v15-latin-500.acb3d87c.svg";